import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useAppDispatch } from '../hooks'
import { recoverAccount } from '../store/auth.slice'
import { NavBack } from '../components/nav-back'
import { Spinner } from '../components/spinner'
import { Status } from '../components/status'

export const RecoverAccountView = () => {
  const [email, setEmail] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [requestState, setRequestState] = useState({ success: '', error: '' })

  const dispatch = useAppDispatch()
  const [searchParams] = useSearchParams()
  const defaultEmail = searchParams.get('addr')

  useEffect(() => {
    defaultEmail && setEmail(defaultEmail)
  }, [defaultEmail])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)

  const getIsSubmitValid = (): boolean => !!email && !requestState.success

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    try {
      setIsLoading(true)

      const { status } = await dispatch(recoverAccount(email)).unwrap()
      if (status === 200) {
        setRequestState({ success: 'Password reset link sent', error: '' })
      }
    } catch (error: any) {
      setRequestState({ success: '', error: error.message })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className='main_content experience_content experience_content-alt'>
      <NavBack />
      {requestState.success && <Status success={requestState.success} />}
      {requestState.error && (
        <Status
          error={requestState.error}
          reset={() => setRequestState({ ...requestState, error: '' })}
        />
      )}
      <div>
        <h1 className='heading-styled'>Recover your account...</h1>
        <p>
          An email with a <em>password reset link</em> will be sent to the email address you provide
          below. Follow the link in the email to reset your password.
        </p>
        <form onSubmit={handleSubmit} className='form-grid'>
          <label htmlFor='email'>Email address:</label>
          <input
            id='email'
            type='email'
            value={email}
            onChange={handleChange}
            required
            readOnly={!!requestState.success}
          />
          {getIsSubmitValid() && (
            <button className='submit' disabled={isLoading}>
              {isLoading ? <Spinner /> : <span>Send email</span>}
            </button>
          )}
        </form>
      </div>
    </div>
  )
}
